import { FC } from 'react';
import Typography from 'src/common/components/Typography';

export type CancelPolicySummaryProps = {
  cancellation_refund: number;
  cancellation_anticipation: number;
};

const CancelPolicySummary: FC<CancelPolicySummaryProps> = ({
  cancellation_refund,
  cancellation_anticipation,
}) => (
  <span>
    <Typography type="span" weight="semibold">
      {cancellation_refund}
      {'%'}
    </Typography>
    {' refund within '}
    <Typography type="span" weight="semibold">
      {cancellation_anticipation <= 1
        ? '24 hours'
        : `${cancellation_anticipation} days`}
    </Typography>
    {' of your trip'}
  </span>
);

export default CancelPolicySummary;
